// extracted by mini-css-extract-plugin
export var cardContainer = "H_ch";
export var ourValues = "H_cg";
export var title = "H_7";